var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"user:login":_vm.login}},[_c('div',{attrs:{"id":"wrapper"}},[_c('MenuSideBar',{attrs:{"width":12,"userLogged":_vm.userLogged}}),_c('div',{staticClass:"page-content-wrapper"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }